import { TruckStatus } from "./truck";
import { mapUserResponse, type User } from "./user";

export interface TruckHistory {
  _id: string;
  truckId: string;
  location?: {
    cityId: string;
  };
  destination?: {
    cityId: string;
  };
  status: TruckStatus;
  timestamp: string;
  notes?: string;
  user: User;
  isDeleted: boolean;
  deletedBy?: User;
  deletedAt?: string;
  createdAt?: string;
}

export interface TruckHistorySearchFilters {
  truckId?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

// Mapper functions
export const mapTruckHistoryResponse = (response: any): TruckHistory => {
  return {
    _id: response._id,
    truckId: response.truckId,
    location: response.location
      ? {
          cityId: response.location.cityId,
        }
      : undefined,
    destination: response.destination
      ? {
          cityId: response.destination.cityId,
        }
      : undefined,
    status: TruckStatus[response.status as keyof typeof TruckStatus] || TruckStatus.UNKNOWN,
    timestamp: response.timestamp,
    notes: response.notes,
    user: mapUserResponse(response.user),
    isDeleted: response.isDeleted || false,
    deletedBy: response.deletedBy ? mapUserResponse(response.deletedBy) : undefined,
    deletedAt: response.deletedAt,
    createdAt: response.createdAt,
  };
};

export const mapTruckHistoriesResponse = (response: any): TruckHistory[] => {
  if (!response.data || !Array.isArray(response.data.truckHistories)) {
    return [];
  }
  return response.data.truckHistories.map(mapTruckHistoryResponse);
};
